import React from 'react';

interface AddSeriesColumnProps {
  children: React.ReactNode;
  className?: string;
}

const AddSeriesColumn: React.FC<AddSeriesColumnProps> = ({ children, className = '' }) => {
  return <div className={`flex flex-col ${className}`}>{children}</div>;
};

export default AddSeriesColumn;
